import React from 'react';
import { hydrate } from 'react-dom';
import { getSharedConfig, mainBundleConfig, setSharedConfig, StoreConfig } from '@okapi/store-config';
import { getApp, setApp, setWidget, setWidgetsMarkup } from '@okapi/dom-utils';
export const runtimeSymbol = Symbol.for('__$OkapiRuntime__');
export function getRuntime() {
    if (!window[runtimeSymbol]) {
        window[runtimeSymbol] = createRuntime();
    }
    return window[runtimeSymbol];
}
function createRuntime() {
    window.widgets = {};
    window.apps = {};
    window.widgets_markup = window.widgets_markup || {};
    const storeConfig = StoreConfig.fromMainBundle(mainBundleConfig());
    setSharedConfig(storeConfig);
    window.addEventListener('DOMContentLoaded', runApp, { once: true, passive: true });
    return {
        registerApp: ({ name, render }) => {
            setApp(name, render);
        },
        registerWidget: ({ name, render }) => {
            setWidget(name, render);
        },
        helmetContext: {},
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isElementWithDataset = (el) => typeof el === 'object' && 'dataset' in el;
function runApp() {
    let remotes = Array.from(document.querySelectorAll('[data-remote]'));
    remotes.forEach(remote => {
        if (remote.dataset.id &&
            isElementWithDataset(remote.children[0]) &&
            remote.children[0].dataset.content === remote.dataset.id) {
            setWidgetsMarkup(remote.dataset.id, remote.children[0].innerHTML);
        }
    });
    const storeConfig = getSharedConfig();
    const App = getApp(storeConfig.name);
    if (App) {
        hydrate(React.createElement(App, null), document.getElementById('root'));
    }
    else {
        throw new Error('Okapi error! It seems to your app isn\'t loaded well.');
    }
}
